import { render, staticRenderFns } from "./ProjectsLegend.vue?vue&type=template&id=3f3e85d7&"
import script from "./ProjectsLegend.vue?vue&type=script&lang=js&"
export * from "./ProjectsLegend.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsLegend.vue?vue&type=style&index=0&id=3f3e85d7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports